export default "https://cdn-static.gokick.com/assets/fe83fbcc8f1f3696644045565519fd390c3f6ffc/images/Sleep_Web_Bottle.d29a408775b1bc1a14ec87c9335374d5.png";